import { SVG, SVGProps } from './svg'

export function IconChevronRight(props: SVGProps) {
  return (
    <SVG {...props} viewBox={props.viewBox ?? '0 0 24 24'}>
      <path d="m15.8 11.3.2.5v.4c0 .2 0 .4-.2.5l-5.2 5.1a.5.5 0 0 1-.7 0l-.7-.7a.5.5 0 0 1 0-.7l4.5-4.4-4.5-4.4a.5.5 0 0 1 0-.8l.7-.7a.5.5 0 0 1 .7 0l5.2 5.2Z" />
    </SVG>
  )
}
